// extracted by mini-css-extract-plugin
export default {"link":"PageNav_link__Ql51R","linkActive":"PageNav_linkActive__aYdzA"};